/* eslint-disable */
import axios from 'axios'
import {fetch} from 'whatwg-fetch'
const SETTINGS = require('./../../constants')
const env = require('./../../../.environment')
const JWTDecode = require('jwt-decode')
const AUTH_METHODS = {
  [SETTINGS.JOBSEEKER_PROFILE_TYPE]: 'jobseekers.profile.get_current',
  [SETTINGS.EMPLOYER_PROFILE_TYPE]: 'employers.profile.get_current',
  [SETTINGS.SENDER_PROFILE_TYPE]: 'senders.profile.get_current',
  [SETTINGS.RECEIVER_PROFILE_TYPE]: 'receivers.profile.get_current'
}
function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
  ))
  return matches ? decodeURIComponent(matches[1]) : undefined
}
/* eslint-enable */

function getRefreshToken (tokenName) {
  if (getCookie(tokenName)) {
    return getCookie(tokenName)
  }
  localStorage.removeItem('jwt_auth_token')
}

let hash

const getVersionHash = () => {
  return new Promise((resolve, reject) => {
    fetch('/webapp/meta.json').then(res => {
      return res.json()
    }).then(meta => {
      hash = meta.WEBAPP_VERSION_HASH
      resolve(hash)
    }).catch(err => {
      hash = ''
      reject(err)
    })
  })
}

const setHash = () => {
  return new Promise((resolve, reject) => {
    if (hash) {
      localStorage.setItem('WEBAPP_VERSION_HASH', hash)
      resolve()
    } else {
      getVersionHash().then(res => {
        localStorage.setItem('WEBAPP_VERSION_HASH', res)
        resolve(res)
      }).catch(err => {
        localStorage.setItem('WEBAPP_VERSION_HASH', 'NULL')
        reject(err)
      })
    }
  })
}

const getHash = () => {
  return localStorage.getItem('WEBAPP_VERSION_HASH')
}

const hashProccessor = async () => {
  await getVersionHash()
  if (hash) {
    if (getHash() !== hash) {
      localStorage.removeItem('WEBAPP_VERSION_HASH')
      await setHash()
      location.reload()
    }
  } else {
    await setHash()
  }
}

const _auth = () => {
  let expires = (new Date((new Date()).getTime() + 12096e5)).toUTCString() // TODO: fix this
  document.cookie = `rememberMe=true; expires=${expires}; secure=true` // TODO: fix this
  setHash()
  return {
    request (req, token) {
      this.options.http._setHeaders.call(this, req, {'RPC-Authorization': `JWT ${token}`})
    },
    response (res) {
      const token = (res.data.result || {}).jwt_access_token
      if (token) {
        let userData = JWTDecode(token)
        this.options.fetchData.data.method = AUTH_METHODS[userData.profile_type] || AUTH_METHODS[SETTINGS.JOBSEEKER_PROFILE_TYPE]
        try {
          this.options.refreshData.data.params = {
            'csrf_token': getRefreshToken('jwtauth_csrf_token')
          }
        } catch (e) {
          console.log('REFRESH_ERROR:', e)
        }
      }
      return token
    }
  }
}

const _refreshData = () => {
  const data = {
    'jsonrpc': '2.0',
    'method': 'userauth.jwtauth.refresh_tokens',
    'params': {
      'csrf_token': getRefreshToken('jwtauth_csrf_token')
    },
    'id': Math.floor(Math.random() * 100)
  }
  return {
    url: env.RPC_ENDPOINT,
    method: 'POST',
    headers: { 'content-type': 'application/json-rpc' },
    data: data,
    enabled: true,
    interval: 0,
    error: function () {
      localStorage.removeItem('jwt_auth_token')
      localStorage.removeItem('WEBAPP_VERSION_HASH')
    }
  }
}

const _axiosDriver = {
  _init: function () {
    if (!this.options.Vue.axios) {
      return 'axios.js : Vue.axios must be set.'
    }
  },

  _interceptor: function (req, res) {
    let _this = this
    if (req) {
      this.options.Vue.axios.interceptors.request.use(function (request) {
        req.call(_this, request)
        return request
      }, function (error) {
        req.call(_this, error.request)
        hashProccessor()
        return Promise.reject(error)
      })
    }

    if (res) {
      this.options.Vue.axios.interceptors.response.use(async (response) => {
        res.call(_this, response)
        if (response.data.error) {
          if (response.data.error.code !== 3030) {
            hashProccessor()
          }
          if (response.response) {
            res.call(_this, response.response)
          }
          if (response.data.error.code === 3040 || response.data.error.code === 3045) {
            localStorage.clear()
          }
          return Promise.reject(response)
        } else {
          return response
        }
      }, function (error) {
        if (error && error.response) {
          res.call(_this, error.response)
        }
        hashProccessor()
        return Promise.reject(error)
      })
    }
  },

  _invalidToken: function (res) {
    const errorCodes = [
      3010,
      3012,
      3013,
      3045,
      3020,
      3025,
      3030,
      3035
    ]
    if (res.status === 401) {
      return true
    } else if (errorCodes.indexOf((res.data.error || {}).code) !== -1) {
      return !((res.data.error || {}).code === 3030)
    }
  },

  _httpData: function (res) {
    return res.data || {}
  },

  _http: function (data) {
    let http = this.options.Vue.axios(data)
    http.then(data.success, data.error)

    return http
  },

  _getHeaders: function (res) {
    return res.headers
  },

  _setHeaders: function (req, headers) {
    req.headers.common = Object.assign({}, req.headers.common, headers)
  }
}

const _fetchData = () => {
  let method = AUTH_METHODS[SETTINGS.JOBSEEKER_PROFILE_TYPE]
  let token = localStorage.getItem('jwt_auth_token')
  let obj = {}
  try {
    obj = JWTDecode(token)
  } catch (e) {
    obj = {}
  }
  if (token) method = AUTH_METHODS[obj.profile_type]
  const data = {
    'jsonrpc': '2.0',
    'method': method,
    'id': Math.floor(Math.random() * 100)
  }
  return {
    url: env.RPC_ENDPOINT,
    method: 'POST',
    headers: { 'content-type': 'application/json-rpc' },
    data: data,
    success: function (res) {
      let data = res.data ? res.data.result : {}
      this.watch.$bus.$emit('user', data)
    },
    enabled: true
  }
}

const _logoutData = () => {
  const data = {
    'jsonrpc': '2.0',
    'method': 'userauth.jwtauth.logout',
    'id': Math.floor(Math.random() * 100)
  }
  return {
    method: 'POST',
    makeRequest: true,
    headers: { 'content-type': 'application/json-rpc' },
    data: data,
    url: env.RPC_ENDPOINT,
    redirect: {name: 'Login'},
    success: function () {
      localStorage.removeItem('jwt_auth_token')
      localStorage.removeItem('WEBAPP_VERSION_HASH')
    }
  }
}

const __cookie = (function () {
  function setCookie (name, value, timeOffset) {
    console.log(timeOffset)
    let domain = this.options.cookieDomain()
    let expires = (new Date((new Date()).getTime() + timeOffset)).toUTCString()
    let cookie = name + '=' + value + '; Expires=' + expires + ';'
    if (domain !== 'localhost') {
      cookie += ' Path=/; Domain=' + domain + ';'
    }
    document.cookie = cookie
  }
  return {
    remember: function (rememberMe) {
      setCookie.call(this,
        'rememberMe',
        rememberMe === true ? 'true' : 'false',
        rememberMe === true ? 12096e5 : undefined
      )
    },
    set: function (name, value, expires) {
      if (value) {
        setCookie.call(this, name, value, 12096e5)
      }
    },
    get: function (name) {
      let i = document.cookie
      let ii = document.cookie
      let cookie = document.cookie
      cookie = cookie.replace(/;\s+/g, ';')
        .split(';')
        .map(function (s) {
          return s.replace(/\s+=\s+/g, '=').split('=')
        })
      for (i = 0, ii = cookie.length; i < ii; i++) {
        if (cookie[i][0] && cookie[i][0] === name) {
          return cookie[i][1]
        }
      }
      return null
    },
    exists: function (name) {
      return document.cookie.match(/rememberMe/)
    },
    remove: function (name) {
      setCookie.call(this, name, '', -12096e5)
    }
  }
})()
const __token = (function () {
  function tokenName (name) {
    name = name || this.currentToken
    if (name) {
      return name
    }
    if (this.impersonating) {
      return this.options.tokenImpersonateName
    }
    return this.options.tokenDefaultName
  }
  function isLocalStorageSupported () {
    try {
      if (!window.localStorage || !window.sessionStorage) {
        throw new Error('exception')
      }
      localStorage.setItem('storage_test', 1)
      localStorage.removeItem('storage_test')
      return true
    } catch (e) {
      return false
    }
  }
  function isCookieSupported () {
    return true
  }
  function processToken (action, name, token) {
    let i = [tokenName.call(this, name)]
    let ii = [tokenName.call(this, name)]
    let args = [tokenName.call(this, name)]
    if (token) {
      args.push(token)
    }
    for (i = 0, ii = this.options.tokenStore.length; i < ii; i++) {
      if (this.options.tokenStore[i] === 'localStorage' && isLocalStorageSupported()) {
        return localStorage[action + 'Item'](args[0], args[1])
      } else if (this.options.tokenStore[i] === 'cookie' && isCookieSupported()) {
        return __cookie[action].apply(this, args)
      }
    }
  }
  return {
    get: function (name) {
      return processToken.call(this, 'get', name)
    },
    set: function (name, token) {
      return processToken.call(this, 'set', name, token)
    },
    remove: function (name) {
      return processToken.call(this, 'remove', name)
    },
    expiring: function () {
      return false
    }
  }
})()

const _logoutProccess = () => {
  return function _logoutProcess (res, data) {
    __cookie.remove.call(this, this.options.tokenImpersonateName)
    __cookie.remove.call(this, this.options.tokenDefaultName)
    __token.remove.call(this, this.options.tokenImpersonateName)
    __token.remove.call(this, this.options.tokenDefaultName)
    this.watch.authenticated = false
    this.watch.data = null
    if (data.success) { data.success.call(this, res, data) }
    if (data.redirect) {
      this.options.router._routerGo.call(this, data.redirect)
    }
  }
}

export const auth = _auth()
export const logoutProccess = _logoutProccess()
export const refreshData = _refreshData()
export const axiosDriver = _axiosDriver
export const fetchData = _fetchData()
export const logoutData = _logoutData()



// WEBPACK FOOTER //
// ./src/services/AuthHandler/index.js